import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function CalibrationHistory({ selectedEquipment }) {
  const dummyData = selectedEquipment
    ? [
        {
          equipment: "EQ1",
          date: "2023-01-01",
          result: "Pass",
          technician: "John Doe",
        },
        {
          equipment: "EQ2",
          date: "2022-12-15",
          result: "Fail",
          technician: "Jane Smith",
        },
        {
          equipment: "EQ3",
          date: "2022-11-20",
          result: "Pass",
          technician: "Alice Johnson",
        },
      ]
    : [];

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" mb={2}>
        Calibration History
      </Typography>
      {selectedEquipment ? (
        <Paper elevation={3}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Equipment</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Result</TableCell>
                <TableCell>Technician</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dummyData.map((record, index) => (
                <TableRow key={index}>
                  <TableCell>{record.equipment}</TableCell>
                  <TableCell>{record.date}</TableCell>
                  <TableCell>{record.result}</TableCell>
                  <TableCell>{record.technician}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Please select an equipment to view its calibration history.
        </Typography>
      )}
    </Box>
  );
}
